import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Moon8pmAnd7am = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99997 13.9999C11.3137 13.9999 13.9999 11.3137 13.9999 7.99997C13.9999 4.68628 11.3137 2 7.99997 2C4.68628 2 2 4.68628 2 7.99997C2 11.3137 4.68628 13.9999 7.99997 13.9999Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Moon8pmAnd7am;
